import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UploadDocument } from '../../modal/upload/model/upload.model';



@Injectable({
  providedIn: 'root'
})
export class UploadService {
  private baseUrl = `${environment.APIUrl}/media/transaction/cfi/documents/`; // adjust to your backend API

  constructor(private http: HttpClient) {}

  addAuthHeaders() {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${sessionStorage.getItem('access')}`);
    console.log('>>>>>>token', sessionStorage.getItem('access'));
    headers = headers.set('Authorized-By', `${sessionStorage.getItem('user_id')}`);
    return headers;
  }
  
  uploadFileWithData(formData: FormData): Observable<any> {
  return this.http.post(`${this.baseUrl}`, formData, {
    reportProgress: true,
    observe: 'events'
  });
}
// Need Generation 
uploadneedGenData(formData: FormData): Observable<any> {
  const url = `${environment.APIUrl}/transaction/dms/files/`;
  return this.http.post(url, formData, {
    headers: this.addAuthHeaders(),
    reportProgress: true,
    observe: 'events'
  });
}
updateUploadNeedGenData(id: number, formData: FormData): Observable<any>{
  const url = `${environment.APIUrl}/transaction/dms/files/${id}/`;
  return this.http.put(url,formData,{
    headers: this.addAuthHeaders(),
    reportProgress:true,
    observe:'events'
  })
}
deleteUploadNeedGenData(id:number): Observable<any>{
  const url = `${environment.APIUrl}/transaction/dms/files/${id}/`;
  return this.http.delete(url,{
    headers: this.addAuthHeaders(),
  })
}


  uploadFile(file: File): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append('file', file);

    const req = new HttpRequest('POST', `${this.baseUrl}/upload`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  getDocuments(): Observable<UploadDocument[]> {
    return this.http.get<UploadDocument[]>(`${this.baseUrl}`);
  }

  deleteDocument(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

  downloadDocument(id: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/download/${id}`, { responseType: 'blob' });
  }
}
